export default __webpack_public_path__ + "static/media/gallery_01.08e2e2ba.jpg";